import React, { Fragment, useState, useEffect } from 'react';
import $ from 'jquery';
import { getCookie, setCookie } from '../utils/cookie';
import { WebSkin, SiteBrand } from '../shared/enums';
import { checkMobileAgent } from '../utils/common';
import Label from '../utils/label';

import { PreloadingSpinDefault, PreloadingSpin188 } from './common/Icon/PreloadingSpin';

function checkIframeLoaded() {
	const iframe = document.getElementById('sportsFrame');
	if (iframe !== null && iframe !== 'undefined') {
		try {
			const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
			if (iframeDoc.readyState === 'complete') {
				afterLoading();
				return;
			}
		} catch (err) {}
	}
	window.setTimeout(checkIframeLoaded, 1000);
}

function afterLoading() {
	const execSportsJS = getCookie('execSportsJS');
	setCookie('execSportsJS', '');
	var execJSs = execSportsJS.split('|');
	for (var i in execJSs) {
		switch(execJSs[i]) {
			case "ReloadBetListMini":
				document.getElementById('sportsFrame').contentWindow.leftFrame.ReloadBetListMini('no','no');
			break;
			case "refreshAccountInfo":
				document.getElementById('sportsFrame').contentWindow.leftFrame.refreshAccountInfo('mini');
			break;
			case "closeBalance":
				document.getElementById('sportsFrame').contentWindow.leftFrame.closeBalance();
			break;
		}
	}
	//eval(execSportsJS);
}

export default function Sportsbook ({webSkinType, siteBrand, isAthena, openDivType, popupDiv, showBanner, paraConfig, promoNewVersionIsShow}) {
	const [FrameHeight, setFrameHeight] = useState(0);
	const [ShowPreloginSpin, setShowPreloginSpin] = useState(false);
	const [Url, setUrl] = useState("");
	const [Init, setInit] = useState(true)

	const SetFrameHeight = () => {
		const header = document.getElementsByTagName('header');
		let cutval = 0;
		if (header.length > 0) {
			cutval = header[0].offsetHeight + 5;
		}
		setFrameHeight(window.innerHeight - cutval);
	};

	const onLoad = () => {
		if(openDivType === 6) {
			popupDiv(-1);
		}
		setShowPreloginSpin(false);
	};
	
	useEffect(()=>{
		SetFrameHeight();
		$(window).resize(SetFrameHeight);
		return() => {
			$(window).unbind('resize', SetFrameHeight);
		};
	},[SetFrameHeight])


	useEffect(()=>{
		if(webSkinType && webSkinType!=="" && paraConfig) {
			setUrl('EntryIndex/OpenSports?' + paraConfig);
			SetFrameHeight();
			setShowPreloginSpin(true);
		}
	},[paraConfig, webSkinType, Init]);

	
	useEffect(()=>{
		if (webSkinType && webSkinType!=="" && Init && showBanner) {
			popupDiv(5);
			setInit(false);
		}
	},[webSkinType, Init]);

	const execSportsJS = getCookie('execSportsJS');
	if(execSportsJS) {
		window.setTimeout(checkIframeLoaded, 5000);
	}

	const isMainSkins = [WebSkin.ASIA_NEW, WebSkin.CHINA_VIEW, WebSkin.VIEW188, WebSkin.ASIA].includes(webSkinType.toString());
	const width = isMainSkins || !isAthena ? '100%' : '1024';
	const adjustedHeight = isMainSkins || !isAthena ? FrameHeight : FrameHeight  - 29;
	const mobileClass = checkMobileAgent() ? "iframe-page" : "";
	const preloadingText = Label.lbl_PreloadSportsbook;

	return (
		<Fragment>
			{ShowPreloginSpin && ({
				[SiteBrand.SABA]: <PreloadingSpinDefault text={preloadingText} />,
				[SiteBrand.CV]: <PreloadingSpin188 />
			}[siteBrand])}

			<div className={mobileClass}>
				<iframe id="sportsFrame" name="sportsFrame" src={Url} onLoad={()=>{onLoad();}} width={width} height={adjustedHeight} style={{border:'none', position: promoNewVersionIsShow ? 'fixed' : ''}}  allowFullScreen/>
			</div>
		</Fragment>
	);
}